import { useAuthStore } from '@/stores/authStore'
import { useNavigate } from 'react-router-dom'
import { LogOut, User } from 'lucide-react'
import HelpButton from '@/components/HelpButton'

export default function Header() {
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()

  const handleLogout = async () => {
    // Awaited, and the login page is told this was deliberate: it signs in automatically
    // otherwise, and the 42QLabs session outlives this one, so logging out would put you
    // straight back in.
    await logout()
    navigate('/login?signed_out=1')
  }

  return (
    <header className="h-16 bg-card border-b border-border flex items-center justify-between px-6">
      <div>
        {/* Page title + contextual help (shown on documented screens) */}
        <HelpButton />
      </div>

      <div className="flex items-center gap-4">
        {/* User info */}
        <div className="flex items-center gap-2 text-sm">
          <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center">
            <User className="h-4 w-4 text-primary" />
          </div>
          <div>
            <div className="font-medium">{user?.full_name || user?.email}</div>
            <div className="text-xs text-muted-foreground">{user?.role}</div>
          </div>
        </div>

        {/* Logout button */}
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 px-3 py-2 text-sm text-muted-foreground hover:text-foreground rounded-md hover:bg-muted transition-colors"
        >
          <LogOut className="h-4 w-4" />
          Logout
        </button>
      </div>
    </header>
  )
}
